"use client";

import { showPopup } from "./Popup";

let activeTimer: NodeJS.Timeout | null = null;

export function showRateLimitWarning(
  limitFreq: "minute" | "daily",
  resetTimeMs: number
) {
  if (activeTimer) clearInterval(activeTimer);

  const update = () => {
    const diff = resetTimeMs - Date.now();

    if (diff <= 0) {
      showPopup("You can now use the API again.", "Rate Limit Reset");
      if (activeTimer) clearInterval(activeTimer);
      activeTimer = null;
      return;
    }

    const s = Math.floor(diff / 1000);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;

    const timeLeft = `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;

    const msg =
      limitFreq === "minute"
        ? `Minute API rate limit exceeded. Try again in ${timeLeft}.`
        : `Daily API rate limit exceeded. Try again in ${timeLeft}.`;

    showPopup(msg, "API Rate Limit Exceeded");
  };

  // Immediately show first popup
  update();

  // Update popup every 1 second
  activeTimer = setInterval(update, 1000);
}
